define([
    "services/requests",
    "helpers/apiHelper"
], function (requests, apiHelper) {
    "use strict";

    var exports = {
        getAllForProject: function(dispatchProjectCode, dispatchDate) {
            return requests.getJson(apiHelper.getProjectDailyEntryBaseUrl(dispatchProjectCode, dispatchDate) + "/additionalfields");
        },

        setAllForProject: function(dispatchProjectCode, dispatchDate, data) {
            return requests.post(apiHelper.getProjectDailyEntryBaseUrl(dispatchProjectCode, dispatchDate) + "/additionalfields", data);
        },

        getAllForDispatch: function (serviceType, dispatchId) {
            return requests.getJson(apiHelper.getDispatchBaseUrl(dispatchId) + '/' + (serviceType === 'W' ? 'workorder' : 'callreturn') + "/additionalfields");
        },

        getAllForServiceCall: function (dispatchId) {
            return requests.getJson(apiHelper.getDispatchBaseUrl(dispatchId) + "/service-call/additionalfields");
        },

        getAllForServiceCallContract: function (dispatchId) {
            return requests.getJson(apiHelper.getDispatchBaseUrl(dispatchId) + "/service-call/contract/additionalfields");
        },

        setAllForDispatch: function (serviceType, dispatchId, data) {
            return requests.post(apiHelper.getDispatchBaseUrl(dispatchId) + '/' + (serviceType === 'W' ? 'workorder' : 'callreturn') + "/additionalfields", data);
        },

        getAllForFieldService: function (workOrderId) {
            return requests.getJson(apiHelper.getWorkOrderBaseUrl(workOrderId) + "/additionalfields");
        },

        setAllForFieldService: function (workOrderId, data) {
            return requests.post(apiHelper.getWorkOrderBaseUrl(workOrderId) + "/additionalfields", data);
        },

        getAllForPurchaseOrder: function (orderId, extension) {
            var url = apiHelper.getPurchaseOrderBaseUrl(orderId) + "/additionalfields";
            if (extension !== "") {
                url += "?extension=" + extension;
            }
            return requests.getJson(url);
        },

        setAllForPurchaseOrder: function (orderId, extension, data) {
            var url = apiHelper.getPurchaseOrderBaseUrl(orderId) + "/additionalfields"
            if (extension !== "") {
                url += "?extension=" + extension;
            }
            return requests.post(url, data);
        }
    };

    return exports;
});
